import React from "react";
import Img from "gatsby-image";
import styled from "styled-components";
import { toHTML } from "../../utils/helpers/index";
import { respondTo } from "../../styles";
import {
  TextEditor,
  PageSection,
  PageSectionArticle,
  PageSectionBackdrop,
} from "../common";
import { ImageWrapperRectangle } from "../common/ImageWrapper";

const StartPageTestimonialsContainer = styled.div`
  display: flex;
  flex-flow: column wrap;

  ${respondTo.lg`
    flex-direction: row;
    margin-bottom: 50px;
  `}
`;

const StartPageTestimonialsBox = styled.div`
 // font-size: 14px;
 // font-weight: 700;
  margin-bottom: 30px;

  ${respondTo.lg`
    margin-bottom: 0;
    width: 33.33333333333%;
    padding-right: 26px;
  `}

  p {
    margin-bottom: 12px;
    font-style: normal;
  }
  ${ImageWrapperRectangle} {
    margin-top: 45px;
    margin-bottom: 0px;
  }
`;

export const StartPageTestimonials = ({ startTestimonials }) => {
  const { heading, startTestimonialsList } = startTestimonials;
  return (
    <PageSection bgColor="var(--sandBeige)">
      <PageSectionBackdrop bgColor="var(--sandBeige)">
        <PageSectionArticle>
          <h2>{heading}</h2>
          <StartPageTestimonialsContainer>
            {!!startTestimonialsList &&
              startTestimonialsList.map(({ body, image, altText }, i) => (
                <StartPageTestimonialsBox key={i}>
                  <ImageWrapperRectangle>
                    <Img fluid={image.childImageSharp.fluid} alt={altText} />
                  </ImageWrapperRectangle>
                  <p>
                    <TextEditor dangerouslySetInnerHTML={{ __html: toHTML(body) }} />
                  </p>
                </StartPageTestimonialsBox>
              ))}
          </StartPageTestimonialsContainer>
        </PageSectionArticle>
      </PageSectionBackdrop>
    </PageSection>
  );
};
